import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=61820e5a&scoped=true&"
import script from "./Paging.vue?vue&type=script&lang=js&"
export * from "./Paging.vue?vue&type=script&lang=js&"
import style0 from "./Paging.vue?vue&type=style&index=0&id=61820e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61820e5a",
  null
  
)

export default component.exports